// extracted by mini-css-extract-plugin
module.exports = {"container":"filters-menu_container__1MAP6","actionTab":"filters-menu_actionTab__318vN","active":"filters-menu_active__3jZfk"};